import React from "react";
import "../../Styles/Modal.css";

function LogoutModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="confirm-modal">
        <button className="modal-close-btn" onClick={onClose}>
          ✕
        </button>

        <h2>Confirm Logout</h2>

        <p>You are about to log out of WedLuk</p>

        <div className="modal-actions">
          <button className="confirm-btn" onClick={onConfirm}>
            Confirm
          </button>

          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogoutModal;